import $ from 'jquery'
import '@fortawesome/fontawesome-free/js/all.js'
import 'desvg'
import SmoothScroll from 'smooth-scroll'
import JSAlert from 'js-alert'
import Analytics from 'analytics'

import googleTagManager from '@analytics/google-tag-manager'

/*
import '@material/web/button/filled-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/checkbox/checkbox.js';
*/

//const smoothScroll = new SmoothScroll('a[href*="#"]')
export const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

export const setReplaceSvg = (selector = null) => {
    const selectorBase = selector ? `${selector} ` : ''
    deSVG(`img[inline]`, true)
}

export const imgPreload = imgPathList => {
    return Promise.all(imgPathList.map(_path => {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
                resolve();
            }
            img.onerror = () => {
                reject();
            }
            img.src = _path;
        })
    }))
}

export const isAppWebBrowser = () => {
    const userAgent = navigator.userAgent;
    return /(Line|Instagram|FB)/i.test(userAgent);
}
export const url2link = (selector = 'main') => {
    document.querySelectorAll(selector).forEach((content) => {
        content.innerHTML = content.innerHTML.replace(/(https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)/g, "<a href=\"$1\" target=\"_blank\">$1</a>");
    });
}

export const loadRecaptchaScript = (siteKey, actionName, recaptchaTokenId = 'recaptcha-token') => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`
    script.async = true
    script.defer = true
    script.onload = () => {
        console.log('reCAPTCHA is loaded and ready.');
    }

    document.head.appendChild(script)
}

const setAnalytics = () => {
    if (document.querySelector('meta[name="gtm_id"]') == null || !document.querySelector('meta[name="gtm_id"]').getAttribute('content')) return;

    const gtm_id = document.querySelector('meta[name="gtm_id"]').getAttribute('content')
    const analytics = Analytics({
        app: 'ritoremo',
        plugins: [
            googleTagManager({
                containerId: gtm_id
            })
        ]
    })

    window.analytics = analytics
}

export const isChatMode = () => {
    console.log('Contact mode:', process.env.MIX_APP_CONTACT_MODE);
    return process.env.MIX_APP_CONTACT_MODE === 'chat'
}

export const checkRoom = async ({jobId, userId, userType, authType}) => {
    if (!isChatMode()) return;
    const response = await fetch('/api/chat/room/check', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-CSRF-TOKEN': csrfToken,
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
            member_id: userId,
            member_type: userType,
            job_id: jobId,
            auth_type: authType,
        }),
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        alert('チャットルームの確認に失敗しました。');
        return null;
    }

    const respData = await response.json();
    if ('path' in respData) {
        location.href = respData.path;
    } else {
        alert('チャットルームの確認に失敗しました。');
        return null;
    }
}

const mediaQuery = window.matchMedia('(max-width: 768px)')
let is_sp = mediaQuery.matches;
mediaQuery.addListener((e) => {
    is_sp = e.matches;
});

export const isSp = () => {
    return is_sp
}

if (!window.analytics) {
    setAnalytics()
}
